import React, { useRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import useApi from '../../hooks/useApi';
import useSnackbar from '../../hooks/useSnackbar';
import { FormControl, TextField } from '@mui/material';

const EditCampaignLinkDialog = ({ campaignID, linkID, url, onSave, onClose }) => {
    const { handlePut } = useApi();
    const { showSnackbar } = useSnackbar();
    const [editedUrl, setEditedUrl] = useState(url);
    const formRef = useRef(null);

    const handleSaveLink = async (e) => {
        e.preventDefault();

        const response = await handlePut(`superadmin/campaigns/${campaignID}/links/${linkID}`, { url: editedUrl });

        if (!response.ok) {
            showSnackbar('An error occured', 'error');
            return;
        }

        showSnackbar('Link updated', 'success');
        onSave();
    };

    return (
        <Dialog onClose={onClose} open={true}>
            <DialogTitle>Edit Link</DialogTitle>
            <form ref={formRef} onSubmit={handleSaveLink}>
                <DialogContent>
                    <FormControl fullWidth margin="none">
                        <TextField
                            fullWidth
                            margin="none"
                            variant="outlined"
                            size="small"
                            label="URL"
                            autoComplete="off"
                            minRows={1}
                            maxRows={4}
                            multiline
                            value={editedUrl}
                            onChange={e => setEditedUrl(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    formRef.current?.requestSubmit();
                                }
                            }}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button type="submit">Save</Button>
                    <Button onClick={onClose}>Cancel</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default EditCampaignLinkDialog;